let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("34Ulx")).then(() => parcelRequire('2SeLy'));